
if (!customElements.get('pc-scroll-gallery')) {
 class PCScrollGallery extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController(); this.frame = 0;
   this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
   this.mobile = matchMedia('(max-width: 749px)');
   this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame = 0; this.update();}); };
   this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();}, {rootMargin:'150px'});
   this.observer.observe(this);
   window.addEventListener('scroll',this.schedule,{passive:true,signal:this.abort.signal});
   window.addEventListener('resize',this.schedule,{passive:true,signal:this.abort.signal});
   this.reduced.addEventListener('change',this.schedule,{signal:this.abort.signal});
   this.schedule();
  }
  update() {
   const disabled = this.reduced.matches || (this.mobile.matches && this.dataset.mobile !== 'true');
   if (!this.visible && !disabled) return;
   this.querySelectorAll('.pc-motion-transform').forEach(el => {
    if (disabled) {el.style.transform='none';return;}
    const rect = el.parentElement.getBoundingClientRect();
    const progress = Math.max(-1,Math.min(1,((innerHeight/2)-(rect.top+rect.height/2))/((innerHeight+rect.height)/2)));
    el.style.transform = `translateY(${progress*Number(el.dataset.y)}px) rotate(${progress*Number(el.dataset.rotate)}deg) scale(${1+((progress+1)/2)*Number(el.dataset.zoom)/100})`;
   });
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 }
 customElements.define('pc-scroll-gallery',PCScrollGallery);
}

// Shared delegated handlers also support sections reloaded by the theme editor.
(() => {
 let frame=0;
 const update=()=>{frame=0;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.pc-blur-frame').forEach(el=>{
   const r=el.getBoundingClientRect();
   el.style.setProperty('--pc-visible-top',`${Math.max(0,Math.min(r.height,-r.top))}px`);
   el.style.setProperty('--pc-visible-bottom',`${Math.max(0,Math.min(r.height,r.bottom-innerHeight))}px`);
   el.querySelectorAll('.pc-blur-edge').forEach(edge=>edge.hidden=reduced || r.bottom<0 || r.top>innerHeight);
  });
  document.querySelectorAll('.pc-hotspot[open]').forEach(positionCard);
 };
 function positionCard(details){
  const card=details.querySelector('.pc-hotspot-card'),stage=details.closest('.pc-hotspot-stage');
  if(!card||!stage)return;
  const a=details.getBoundingClientRect(),b=stage.getBoundingClientRect();
  const width=card.getBoundingClientRect().width;
  const left=Math.max(8,Math.min(innerWidth-width-8,Math.max(b.left+8,Math.min(b.right-width-8,a.left+a.width/2-width/2))));
  card.style.left=`${left-a.left}px`;
  const available=innerHeight-a.bottom-16;
  card.style.top=available<180 && a.top>200?'auto':'calc(100% + 10px)';
  card.style.bottom=available<180 && a.top>200?'calc(100% + 10px)':'auto';
 }
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
 document.addEventListener('toggle',e=>{if(e.target.matches?.('.pc-hotspot')&&e.target.open){document.querySelectorAll('.pc-hotspot[open]').forEach(x=>{if(x!==e.target)x.open=false});positionCard(e.target)}},true);
 document.addEventListener('click',e=>{const close=e.target.closest('.pc-hotspot-close');if(close){close.closest('details').open=false;close.closest('details').querySelector('summary').focus()}else if(!e.target.closest('.pc-hotspot'))document.querySelectorAll('.pc-hotspot[open]').forEach(x=>x.open=false)});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.pc-hotspot[open]').forEach(x=>{x.open=false;x.querySelector('summary').focus()})});
 window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);schedule();
})();

// Product cover header: no changes to standard headers when disabled.
(() => {
 let raf=0;
 function refresh(){
  raf=0;
  const mobile=matchMedia('(max-width: 749px)').matches;
  const cover=document.querySelector('product-component[data-pc-cover-mobile]');
  const mode=cover?.dataset[mobile?'pcCoverMobile':'pcCoverDesktop'];
  document.querySelectorAll('.header-wrapper[data-pc-overlay]').forEach(header=>{
   const root=header.closest('.shopify-section');
   if(!root)return;
   const enabled=header.dataset.pcOverlay==='true' && !!cover && mode && mode!=='normal';
   root.classList.toggle('pc-header-overlay',!!enabled);
   if(!enabled){root.classList.remove('pc-header-scrolled');root.style.removeProperty('--pc-header-top');return;}
   const scrolled=window.scrollY>Number(header.dataset.pcThreshold||60);
   root.classList.toggle('pc-header-scrolled',scrolled);
   let offset=0;
   document.querySelectorAll('.shopify-section-group-header-group').forEach(section=>{
    if(section===root || section.contains(root))return;
    const rect=section.getBoundingClientRect();
    if(rect.top<=0 && rect.bottom>0)offset=Math.max(offset,rect.bottom);
    else if(window.scrollY===0 && rect.bottom>0 && rect.bottom<innerHeight/2)offset=Math.max(offset,rect.bottom);
   });
   root.style.setProperty('--pc-header-top',`${Math.max(0,offset)}px`);
  });
 }
 const schedule=()=>{if(!raf)raf=requestAnimationFrame(refresh)};
 window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);document.addEventListener('shopify:section:unload',schedule);
 document.addEventListener('DOMContentLoaded',schedule);schedule();
})();
